import React from "react";
import { Mutation } from "react-apollo";
import { UPDATE_STEAKING, CLOSE_STEAKING } from "../../../queries";

import ArnoGold from "../../../img/IndexMain/arty-gold.png";
import check from "../../../img/IndexMain/check.svg";

class InnerSteak extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            deposit: 0
        };
    }

    ChangeElement = event => {
        let value = event.target.value.replace(/[^1234567890.]/g, '');
        this.setState({deposit : value});
    };

    updateSteakingEvent = (event, updateSteaking) => {
        event.preventDefault();        
        updateSteaking().then(({ data }) => {
            console.log(data.updateSteaking);
            this.props.refetch();
        })
    }; 

    closeSteakingEvent = (event, closeSteaking) => {
        event.preventDefault();        
        closeSteaking().then(({ data }) => {
            console.log(data.closeSteaking);
            this.props.refetch();
            window.open(`https://launchpadadmin.artyfact.game/staking/${this.props.Steak._id}`, '_top');
        })
    }; 
    
    render() {
        let self = this;
        let CanSteak = this.state.deposit <= this.props.session.Balance && this.state.deposit <= this.props.TokenAmount.availableToken && this.state.deposit != 0 && this.state.deposit >= 30 ? true : false;
        let status = this.props.Steak.status ? 'Available' : 'Hold';
        if (this.props.Steak.close) { status = 'Closed' }
        
        let DateForm = `${new Date(+this.props.Steak.DateStart)}`;
        let from = DateForm.search('GMT'); 
        let NewDateForm = DateForm.substring(0,from);

        let DateEndForm = `${new Date(+this.props.Steak.DateEnd)}`;
        from = DateEndForm.search('GMT'); 
        let NewDateFormEnd = DateEndForm.substring(0,from);
        let date2 = new Date(+this.props.Steak.DateStart);
        let DaysPassed = Math.ceil(Math.abs(Date.now() - date2.getTime()) / (1000 * 3600 * 24)) - 1;

        let StartDepo = this.props.Steak.depositStart ? this.props.Steak.depositStart : this.props.Steak.deposit;
        return (
            <div class="row" style={{width: '100%', 'margin-top' : '30px'}}>
                <div class="col-md-4"></div>
                <div class="col-md-4">
                    <div class="package-area2">
                        <div className="package-ttl2" style={{width: '165px'}}>
                            <img className="package-img2" src={ArnoGold} /> STAKING
                        </div>
                        {!this.props.Steak.close &&
                        <>
                            {/* <div className="package-price2">
                                <input className="SumInputDash2" type="text" value={this.state.deposit ? this.state.deposit : ''} name="deposit" placeholder="Enter amount" onChange={this.ChangeElement}/>
                                <div className="package-price-text2">$ARTY</div>
                                <div class="help-sum">{this.state.deposit > this.props.session.Balance && `Maximum ${this.props.session.Balance.toFixed(3)} ARNO`}</div>
                                {this.state.deposit && this.state.deposit < 30 ?
                                    (<div class="help-sum">Minimum 30 ARNO</div>) : (
                                        <></>
                                    )
                                }
                            </div>

                            <div className="custom-separator"></div>

                            <div className="payment-type-area" style={{width: '150px'}}>
                                <div className="PaymentCoin2">
                                    Maximum Available:
                                </div>
                            </div>
                            <div className="PaymentCoinSum2">
                                {this.props.TokenAmount.availableToken.toFixed(2)} ARNO
                            </div> */}
                        </>
                        }
                        
                        <ul class="list-package" style={{width: '90%'}}>
                            <li class="mb-3">
                                <img className="check-img" src={check}/> Deposit: {this.props.Steak.deposit.toFixed(2)} $ARTY
                            </li>

                            <li class="mb-3">
                                <img className="check-img" src={check}/> 1 year interest payment: {this.props.Steak.deposit.toFixed(2) * 1.5} $ARTY
                            </li>
                            <li class="mb-3">
                                <img className="check-img" src={check}/> 2 years interest payment: {this.props.Steak.deposit.toFixed(2) * 3} $ARTY
                            </li>
                            <li class="mb-3">
                                <img className="check-img" src={check}/> 3 years interest payment: {this.props.Steak.deposit.toFixed(2) * 7} $ARTY
                            </li>
                            {/*<li class="mb-3">
                                <img className="check-img" src={check}/> Cost: {this.props.Steak.Cost.toFixed(3)} $ARTY
                            </li>
                            <li class="mb-3">
                                <img className="check-img" src={check}/> Profit: {(this.props.Steak.Profit * 100).toFixed(0)} %
                            </li>
                            <li class="mb-3">
                                <img className="check-img" src={check}/> Profit: {(this.props.Steak.Cost - StartDepo).toFixed(3) } $ARTY
                            </li>*/}
                            <li class="mb-3">
                                <img className="check-img" src={check}/> Days Passed: {DaysPassed}
                            </li>
                            <li class="mb-3">
                                <img className="check-img" src={check}/> Status: {status}
                            </li>
                            <li class="mb-3">
                                <img className="check-img" src={check}/> Date start: {NewDateForm}
                            </li>
                            <li class="mb-3">
                                <img className="check-img" src={check}/> Date end: {NewDateFormEnd}
                            </li>
                        </ul>

                        {/* !this.props.Steak.close &&
                            <div className="total-arno">
                                You can top up $ARTY tokens of current staking
                            </div>
                        */}
                        
                        {/* CanSteak && !this.props.Steak.close ? (
                            <Mutation mutation={UPDATE_STEAKING} variables={{ 
                                steakid: this.props.Steak._id, 
                                deposit: +this.state.deposit 
                            }} >
                                {(updateSteaking, { data, loading, error }) => {
                                    return (
                                        <div className="package-but buy-botton" onClick={event => self.updateSteakingEvent(event, updateSteaking)}>
                                            Add deposit
                                        </div>
                                    )
                                }}
                            </Mutation>
                        ) : (
                            <div className="package-but-disable buy-botton">
                                Add deposit
                            </div>
                        )*/}
                        {this.props.Steak.status && !this.props.Steak.close ? (
                            <Mutation mutation={CLOSE_STEAKING} variables={{ 
                                steakid: this.props.Steak._id,
                            }} >
                                {(closeSteaking, { data, loading, error }) => {
                                    return (
                                        <div className="package-but buy-botton" style={{'margin-top' : '20px'}} onClick={event => self.closeSteakingEvent(event, closeSteaking)}>
                                            Close Staking
                                        </div>
                                    )
                                }}
                            </Mutation>
                        ) : (
                            <div className="package-but-disable buy-botton" style={{'margin-top' : '20px'}}>
                                Close Staking
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default InnerSteak